var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vh-radio-group',{on:{"change":_vm.change},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }